import { Suspense } from 'react';
import GlobalNavbarEN from '../../../components/feature/GlobalNavbarEN';
import FooterEN from '../../home/components/FooterEN';

export default function TermsEN() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <div className="min-h-screen bg-white">
        <GlobalNavbarEN />
        
        {/* Dark Hero Banner - matches other pages */}
        <section className="relative bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900 pt-32 pb-16 px-6">
          <div className="max-w-[900px] mx-auto">
            <h1 className="text-4xl font-bold text-white mb-4">Terms of Service</h1>
            <p className="text-sm text-gray-400">Last Updated: January 2026</p>
          </div>
        </section>

        <main className="py-20">
          <div className="max-w-[900px] mx-auto px-8">
            <div className="space-y-8 text-gray-700 leading-relaxed">
              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Agreement to Terms</h2>
                <p className="mb-4">
                  By accessing or using the website or services provided by DOOHNUTS Inc. ("Company," "we," "us," or "our"), you agree to be bound by these Terms of Service ("Terms").
                </p>
                <p className="mb-4">
                  If you do not agree to these Terms, you must not use our services.
                </p>
                <p>
                  These Terms apply to all visitors, advertisers, property owners, partners, investors, and any other users of our services.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Description of Services</h2>
                <p className="mb-4">
                  DOOHNUTS Inc. provides billboard advertising and related services in Las Vegas, Nevada and surrounding areas.
                </p>
                <p className="mb-4">
                  Services may include, but are not limited to:
                </p>
                <ul className="list-disc pl-6 space-y-2 mb-4">
                  <li>Billboard advertising space rental and management</li>
                  <li>Digital billboard upgrade consulting</li>
                  <li>Advertising campaign planning and execution</li>
                  <li>Partnership discussions and investment-related evaluations</li>
                  <li>ROI simulations and performance analytics</li>
                  <li>Consulting services related to advertising and billboard assets</li>
                </ul>
                <p>
                  We reserve the right to modify, suspend, or discontinue any part of the services at any time without prior notice.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Eligibility</h2>
                <p>
                  You must be at least 18 years old and have the legal capacity to enter into a binding agreement to use our services.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Advertising Content</h2>
                <div className="mb-4">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">4.1 Approval</h3>
                  <p className="mb-2">
                    All advertising materials are subject to review and approval prior to display.
                  </p>
                  <p>
                    We reserve the right to reject, remove, or modify any content that violates applicable laws, regulations, or our internal standards.
                  </p>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">4.2 Responsibility</h3>
                  <p>
                    You are solely responsible for the legality, accuracy, and compliance of all submitted advertising materials.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Fees and Payment</h2>
                <p className="mb-4">
                  Fees are determined by separate agreements or published pricing.
                </p>
                <p className="mb-4">
                  Unless otherwise agreed in writing:
                </p>
                <ul className="list-disc pl-6 space-y-2 mb-4">
                  <li>Payments are due according to agreed terms</li>
                  <li>Advertising campaigns already commenced are non-refundable</li>
                  <li>Late payments may result in suspension of services</li>
                </ul>
                <p>
                  We may charge interest on overdue amounts at the maximum rate permitted by law.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Intellectual Property</h2>
                <p className="mb-4">
                  All content on our website, including but not limited to text, graphics, logos, designs, and software, is the property of DOOHNUTS Inc. or its licensors and is protected under applicable intellectual property laws.
                </p>
                <p>
                  You may not reproduce, distribute, or use our intellectual property without prior written consent.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Investment and ROI Disclaimer</h2>
                <p className="mb-4">
                  Any ROI simulations, revenue projections, performance estimates, or financial information provided by us are for informational purposes only.
                </p>
                <p className="mb-4">
                  They do not constitute financial, investment, tax, or legal advice.
                </p>
                <p className="mb-4">
                  We make no guarantees regarding future performance, profitability, or return on investment.
                </p>
                <p>
                  All business and investment decisions are made at your own risk.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Disclaimer of Warranties</h2>
                <p className="mb-4">
                  Our services are provided on an "AS IS" and "AS AVAILABLE" basis.
                </p>
                <p>
                  To the maximum extent permitted by law, we disclaim all warranties, whether express or implied, including warranties of merchantability, fitness for a particular purpose, and non-infringement.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Limitation of Liability</h2>
                <p className="mb-4">
                  To the fullest extent permitted by law, DOOHNUTS Inc. shall not be liable for any indirect, incidental, consequential, special, or punitive damages, including loss of profits, revenue, data, goodwill, or other intangible losses.
                </p>
                <p>
                  Our total liability for any claim arising out of or related to these Terms or our services shall not exceed the amount paid by you to us in the twelve (12) months preceding the event giving rise to the claim.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Indemnification</h2>
                <p className="mb-4">
                  You agree to indemnify, defend, and hold harmless DOOHNUTS Inc., its officers, directors, employees, and agents from any claims, damages, liabilities, losses, or expenses (including reasonable attorneys' fees) arising out of:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Your use of the services</li>
                  <li>Your advertising content</li>
                  <li>Your violation of these Terms</li>
                  <li>Your violation of any applicable law or third-party rights</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">11. Force Majeure</h2>
                <p>
                  We shall not be liable for any failure or delay resulting from causes beyond our reasonable control.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">12. Termination</h2>
                <p>
                  We may suspend or terminate your access to the services at any time for violation of these Terms or for other lawful reasons.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">13. Governing Law and Dispute Resolution</h2>
                <p className="mb-4">
                  These Terms shall be governed by the laws of the State of Nevada, United States.
                </p>
                <p className="mb-4">
                  Any dispute shall be resolved by binding arbitration in Las Vegas, Nevada.
                </p>
                <p>
                  You waive the right to a jury trial and participation in class actions.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">14. Severability</h2>
                <p>
                  If any provision is found invalid, the remaining provisions remain in effect.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">15. Entire Agreement</h2>
                <p>
                  These Terms constitute the entire agreement between you and DOOHNUTS Inc. regarding the services.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">16. Contact Information</h2>
                <div className="bg-gray-50 p-6 rounded-lg mt-4">
                  <p className="font-semibold text-gray-900 mb-2">DOOHNUTS Inc.</p>
                  <p className="text-sm">Las Vegas, Nevada</p>
                  <p className="text-sm">Email: <a href="mailto:info@doohnutsinc.com" className="text-teal-600 hover:text-teal-700 cursor-pointer">info@doohnutsinc.com</a></p>
                  <p className="text-sm">Phone: <a href="tel:+17024779870" className="text-teal-600 hover:text-teal-700 cursor-pointer">+1 (702) 477-9870</a></p>
                </div>
              </section>
            </div>
          </div>
        </main>

        <FooterEN />
      </div>
    </Suspense>
  );
}
